import { render, staticRenderFns } from "./DashHeader.vue?vue&type=template&id=40c113f2&scoped=true&"
import script from "./DashHeader.vue?vue&type=script&lang=ts&"
export * from "./DashHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c113f2",
  null
  
)

export default component.exports